// extracted by mini-css-extract-plugin
export default {"product_description":"ProductIngredients_product_description__jALNC"};